var loginLockoutTimer = null;

function hideLoginForm() {
    var $form = $('#frm-signIn-form');
    $form.find('label, input, .check-div, button[type=submit]').hide();
}

function showLoginForm() {
    var $form = $('#frm-signIn-form');
    $form.find('label, input, .check-div, button[type=submit]').show();
    // Checkbox „zůstat přihlášen" má jiný display
    $form.find('.check-div').css('display', 'flex');
}

function startLockoutCountdown(retryAfter) {
    var $lockoutMsg = $('#login-lockout-message');
    var $lockoutText = $('#lockout-text');
    var $countdown = $('#login-countdown');

    hideLoginForm();
    $lockoutMsg.show();

    var remaining = retryAfter;

    function updateCountdown() {
        var min = Math.floor(remaining / 60);
        var sec = remaining % 60;
        $countdown.text(min + ':' + (sec < 10 ? '0' : '') + sec);
    }

    updateCountdown();

    if (loginLockoutTimer) {
        clearInterval(loginLockoutTimer);
    }

    loginLockoutTimer = setInterval(function () {
        remaining--;
        if (remaining <= 0) {
            clearInterval(loginLockoutTimer);
            loginLockoutTimer = null;
            $lockoutMsg.hide();
            $countdown.text('');
            showLoginForm();
        } else {
            updateCountdown();
        }
    }, 1000);
}

function showPermanentLockout(message) {
    var $lockoutMsg = $('#login-lockout-message');
    var $lockoutText = $('#lockout-text');
    var $countdown = $('#login-countdown');

    hideLoginForm();
    $lockoutMsg.show();
    $lockoutText.html(message);
    $countdown.text('');
}

function handleLockoutResponse(payload) {
    if (!payload.lockout) {
        return false;
    }

    var $lockoutText = $('#lockout-text');
    $lockoutText.html(payload.error);

    if (payload.permanent) {
        showPermanentLockout(payload.error);
    } else if (payload.retryAfter && payload.retryAfter > 0) {
        startLockoutCountdown(payload.retryAfter);
    }

    return true;
}

/* ===== Domain-based OAuth detection (e.g. company domain → MS Entra) ===== */
function getEmailDomain(value) {
    if (typeof value !== 'string') return null;
    var at = value.lastIndexOf('@');
    if (at === -1) return null;
    var domain = value.substring(at + 1).trim().toLowerCase();
    return domain || null;
}

function applyOAuthDomainState($wrap) {
    var domainMap = $wrap.data('oauth-domain-map') || {};
    var labels = $wrap.data('oauth-provider-labels') || {};
    var redirectBase = $wrap.data('oauth-redirect-base') || '';
    var companyLoginLabel = $wrap.data('oauth-company-login-label') || 'Na firemní přihlášení';

    var $form = $wrap.find('form').first();
    var $loginInput = $wrap.find('input[name="login"]');
    var $passwordRow = $wrap.find('.js-password-row');
    var $longRow = $wrap.find('.js-long-expiration-row');
    var $classicBtn = $wrap.find('.js-classic-submit');
    var $oauthBtn = $wrap.find('.js-oauth-redirect');
    var $oauthLabel = $oauthBtn.find('.js-oauth-button-label');

    var domain = getEmailDomain($loginInput.val());
    var provider = domain && domainMap[domain] ? domainMap[domain] : null;

    if (provider) {
        var label = labels[provider] || provider;
        var url = redirectBase ? redirectBase.replace('__PROVIDER__', encodeURIComponent(provider)) : '#';
        $oauthBtn.attr('href', url);
        $oauthLabel.text(companyLoginLabel + ' (' + label + ')');
        $passwordRow.hide();
        $longRow.hide();
        $classicBtn.hide();
        $oauthBtn.show();
        $wrap.find('input[name="password"]').prop('required', false);
    } else {
        $passwordRow.show();
        $longRow.css('display', 'flex');
        $classicBtn.show();
        $oauthBtn.hide();
        $wrap.find('input[name="password"]').prop('required', true);
    }
}

$(document).on('input change blur', '.js-sign-in input[name="login"]', function () {
    applyOAuthDomainState($(this).closest('.js-sign-in'));
});

$(function () {
    $('.js-sign-in').each(function () {
        applyOAuthDomainState($(this));
    });
});

$(document).on("submit", "#frm-signIn-form", function (e1) {

    e1.preventDefault();

    // If the email's domain maps to an OAuth provider, redirect to provider sign-in instead of submitting credentials.
    let $form = $(this);
    let $oauthBtn = $form.closest('.js-sign-in').find('.js-oauth-redirect');
    if ($oauthBtn.is(':visible')) {
        let href = $oauthBtn.attr('href');
        if (href && href !== '#') {
            window.location.href = href;
        }
        return;
    }

    let butt = $form.find("button.login, input.login, button[type='submit'], input[type='submit']").first();
    if (butt.hasClass('disabled')) {
        return;
    }

    butt.addClass("disabled");
    butt.find(".fa-spinner").show();
    let form = $(this);

    let formData = new FormData(this);
    let formUrl = form.attr("action");

    function auth(formUrl, formData)
    {

        $.nette.ajax({
            url: formUrl,
            data: formData,
            type: 'POST',
            processData: false,
            contentType: false,
            off: {
                snippets: true
            },
            success: function (payload) {

                // Zpracování lockout odpovědi
                if (handleLockoutResponse(payload)) {
                    butt.find(".fa-spinner").hide();
                    butt.removeClass('disabled');
                    return;
                }

                if (payload.error) {
                    toastr.warning(payload.error);
                }
                butt.find(".fa-spinner").hide();
                butt.removeClass('disabled');

                //window.location(payload.redirect);
            },
            error: function (err) {
                if(err.error){
                    toastr.warning(err.error);
                }
                butt.find(".fa-spinner").hide();
                butt.removeClass('disabled');
            }
        });

    }
    if (typeof grecaptcha !== 'undefined') {
        grecaptcha.ready(function () {
            grecaptcha.execute('6Lcwa1gfAAAAAOy4kQrA93K6nJKkbfcQt306b-kn', {action: 'login'}).then(function (token) {
                formData.append('token', token);
                formData.append('action', 'login');
                auth(formUrl, formData);
            }).catch(function () {
                // reCAPTCHA selhala (blokátor reklam apod.) — odešleme formulář bez tokenu
                auth(formUrl, formData);
            });
        });
    } else {
        auth(formUrl, formData);
    }
});
